import {DraftMessageModel} from '../../libs/shared/core/src/models/api/messageModel';

/*
 * Constants.
 */

export const emojiAllowedAttributes = ['front-emoji-shortcode'];
export const inlineAttachmentAllowedAttributes = ['front-cid', 'front-name'];

/*
 * Helpers.
 */

export function wrapMessageWithDivId(html: string, messageId?: number) {
  if (!messageId) {
    return html;
  }

  // If we have a message ID, wrap the HTML with a special div
  // so the styles prefixed by the sanitizer work properly.
  return `<div id="fae_${messageId.toString(36)}">${html}</div>`;
}

export function computeIsDraftInReadMode(
  draft: DraftMessageModel,
  userId: number,
  readonlyDraftMessageUids: ReadonlySet<string>,
  isDraftShared: boolean,
): boolean {
  const isReadonlyDraft = readonlyDraftMessageUids.has(draft.uid);
  const isEditedByOther = draft.authorId !== userId && isDraftShared;
  return isReadonlyDraft || isEditedByOther;
}
